export default __webpack_public_path__ + "static/media/Illustration-SVG.924b9e39.svg";